import Drawer from 'rc-drawer';
import ReactHtmlParser from 'react-html-parser';
import { Panel, Button, Glyphicon, ControlLabel } from 'react-bootstrap';
import { ICenterNotification } from '@nkr/models/index';

interface IProps {
    show: boolean,
    list: ICenterNotification[],
    onMarkRead: (id: number) => void,
    onClose: () => void,
    onGetContainer: () => HTMLDivElement
}

const CenterNotifications: React.FC<IProps> = (props) => {
    const list = props.list.filter(x => x.isRead == false && x.isEnabled);

    return (
        <Drawer
            width="20vw"
            // handler={false}
            placement="right"
            // wrapperClassName='center-notifications'
            getContainer={props.onGetContainer}
            open={props.show}
            style={{ zIndex: 99999999 }}
        >
            {props.show && (
                <div style={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                    <div className='bg-primary' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: 10 }}>
                        <h3 style={{ margin: 0 }}>Center Notifications</h3>
                        <Glyphicon glyph='remove' onClick={props.onClose} />
                    </div>

                    <div style={{ flexBasis: '92%', display: 'flex', flexDirection: 'column', padding: 10 }}>
                        {list.map((item, index) =>
                            <Panel key={`cn-${index}`}>

                                <Panel.Heading style={{ padding: '5px 7.5px', background: "#a6d8a6" }}>

                                    <div className="row">
                                        <div className="col-xs-12">
                                            <div style={{ display: "inline-block" }}>
                                                <ControlLabel>Date Created:</ControlLabel>&nbsp;
                                                {ReactHtmlParser(item.addedDateTime)}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-xs-12">
                                            <div style={{ display: "inline-block" }}>
                                                <ControlLabel>Description:</ControlLabel>&nbsp;
                                                {ReactHtmlParser(item.description)}
                                            </div>
                                        </div>
                                    </div>
                                </Panel.Heading>

                                <Panel.Body>
                                    <ControlLabel>Content:</ControlLabel>
                                    <div>{ReactHtmlParser(item.notificationText)}</div>
                                </Panel.Body>

                                <Panel.Footer style={{ padding: '5px 7.5px' }}>
                                    <div className='text-right'>
                                        <Button bsStyle='primary' bsSize='xs' onClick={() => props.onMarkRead(item.id)}>Click to Acknowledge</Button>
                                    </div>
                                </Panel.Footer>
                            </Panel>
                        )}

                        {list.length == 0 && (
                            <div>There are no notification at this time...</div>
                        )}
                    </div>

                    <div className='text-center bg-info'>
                        <Button bsStyle='link' onClick={props.onClose}>Close this panel...</Button>
                    </div>
                </div>
            )}
        </Drawer>
    );
}

export default CenterNotifications;